import { useMutation, useQueryClient } from '@tanstack/react-query'
import { SPEND_COUNTRY_GROUP_TRANSLATIONS } from 'api/react-query/keys'
import { updateCountryGroupTranslations } from 'SpendControl/endpoints'
import type { PatchCountryGroupTranslations } from 'SpendControl/endpoints/spend-control'

type UpdateCountryGroupTranslationsParams = { id: string } & PatchCountryGroupTranslations

export const useUpdateCountryGroupTranslations = () => {
  const client = useQueryClient()

  return useMutation({
    mutationFn: ({ id, ...body }: UpdateCountryGroupTranslationsParams) => updateCountryGroupTranslations(id, body),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: [SPEND_COUNTRY_GROUP_TRANSLATIONS] })
    },
  })
}
